interface MenuIconProps {
  isOpen: boolean;
  className?: string;
}

export function MenuIcon({ isOpen, className = '' }: MenuIconProps) {
  return (
    <div className={`relative w-6 h-6 ${className}`}>
      {[0, 1, 2].map((index) => (
        <span
          key={index}
          className={`
            absolute 
            left-0 
            w-6 
            h-0.5 
            bg-muted 
            transform 
            transition-all 
            duration-300 
            ease-in-out
            ${index === 0 
              ? isOpen 
                ? 'top-1/2 rotate-45' 
                : 'top-1'
              : index === 1
              ? isOpen
                ? 'opacity-0'
                : 'top-1/2 -translate-y-1/2 opacity-100'
              : isOpen
              ? 'bottom-1/2 -rotate-45'
              : 'bottom-1'
            }
          `}
        />
      ))}
    </div>
  );
} 